import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAccounts } from '../utils/api';
import { useAuth } from './AuthContext';

const AccountContext = createContext();

export function AccountProvider({ children }) {
  const { user } = useAuth();
  const [accounts, setAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState(localStorage.getItem('selectedAccountId') || 'all');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      loadAccounts();
    } else {
      setAccounts([]);
      setSelectedAccountId('all');
    }
  }, [user]);

  const loadAccounts = async () => {
    setLoading(true);
    try {
      const res = await getAccounts();
      setAccounts(res.data || []);
      
      // If the currently selected account is not in the list anymore, revert to 'all'
      if (selectedAccountId !== 'all' && !res.data.find(a => a.id === selectedAccountId)) {
        updateSelectedAccount('all');
      }
    } catch (e) {
      console.error('Failed to load accounts', e);
    }
    setLoading(false);
  };

  const updateSelectedAccount = (id) => {
    setSelectedAccountId(id);
    localStorage.setItem('selectedAccountId', id);
  };

  const selectedAccount = selectedAccountId === 'all' 
    ? null 
    : accounts.find(a => a.id === selectedAccountId);

  return (
    <AccountContext.Provider value={{ 
      accounts, 
      selectedAccountId, 
      selectedAccount,
      updateSelectedAccount, 
      loadAccounts,
      loading 
    }}>
      {children}
    </AccountContext.Provider>
  );
}

export const useAccounts = () => useContext(AccountContext);
